export const GA_KEY = process.env.NEXT_PUBLIC_GA_KEY || "";

export const STRIPE_KEY = process.env.NEXT_PUBLIC_STRIPE_KEY;

export const PUSHER_KEY = process.env.NEXT_PUBLIC_PUSHER_KEY;

export const GOOGLE_CLIENT_ID = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID;

export const CREATOR_GOOGLE_CLIENT_ID =
  process.env.NEXT_PUBLIC_CREATOR_GOOGLE_CLIENT_ID;

export const FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID;

export const VERLOOP_KEY = process.env.NEXT_PUBLIC_VERLOOP_KEY;

export const AB_TESTING_ID = process.env.NEXT_PUBLIC_AB_TESTING_ID;

export const ZOOM_KEY: string = process.env.NEXT_PUBLIC_ZOOM_API_KEY || "";

export const SHOW_ZOOM: string = process.env.NEXT_PUBLIC_SHOW_ZOOM || "";

export const FIRST_PROMOTER_KEY: string =
  process.env.NEXT_PUBLIC_FIRST_PROMOTER_KEY || "";

export const FIRST_PROMOTER_KEY_US: string =
  process.env.NEXT_PUBLIC_FIRST_PROMOTER_KEY_US || "";

export const RECAPTCHA_TOKEN = process.env.NEXT_PUBLIC_RECAPTCHA_TOKEN || "";

export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || "";
